/* Mobile menu: submenu accordion. [data-hds-submenu] toggles its aria-expanded (CSS animates height). */
(function () {
  const panel = document.querySelector('[data-hds-panel="menu"]');
  if (!panel) return;

  panel.querySelectorAll('[data-hds-submenu]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      // Stop the global header-menu.js handler treating this as an accordion trigger (closes siblings).
      e.stopPropagation();
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  /* Collapse all submenus when the menu closes. */
  new MutationObserver(() => {
    if (!panel.hidden) return;
    panel.querySelectorAll('[data-hds-submenu]').forEach((b) => {
      b.setAttribute('aria-expanded', 'false');
    });
  }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
})();
